import { Events } from '../../events/app-events';
import { eventBus } from '../../utils/event-bus';
import { Question } from '../question';

const numberIfNumberlike = (source: string | number): string | number => {
  const asNumber = typeof source === 'string' ? Number(source) : NaN;
  if (isNaN(asNumber)) return source;
  return asNumber;
};

const operators = {
  equal: (a: any, b: any) => a === b,
  equals: (a: any, b: any) => a === b,
  notEqual: (a: any, b: any) => a !== b && a,
  notEquals: (a: any, b: any) => a !== b,
  lessThan: (a: number, b: number) => a < b,
  greaterThan: (a: number, b: number) => a > b,
  greaterThanOrEqual: (a: number, b: number) => a >= b,
  lessThanOrEqual: (a: number, b: number) => a <= b,
  olderThanYears: (a: string, years: number) => {
    const now = new Date();
    const then = new Date();
    then.setFullYear(Number(a));
    const diff = 1000 * 60 * 60 * 24 * 365 * years;
    return (now.valueOf() - then.valueOf() > diff && a != '' && a != null);
  },
} as any;

// exaple: rule::Q_Is_the_insured_the_owner_of_vessel::equal::Yes
function createGenericRule(raw: string) {
  if (!raw.startsWith('rule::')) {
    throw new Error('This is not a generic rule' + raw);
  }
  const expression = raw.slice(6);
  const [affectingQuestionId, operator, comparable] = expression.split('::');
  if (!affectingQuestionId || !operator || typeof comparable === 'undefined') {
    throw new Error(`Could not compile expression ${expression}`);
  }
  const op = operators[operator];
  if (!op) {
    throw new Error(`Invalid operator ${operator}`);
  }

  // try to convert to number value
  return { affectingQuestionId, op, comparable: numberIfNumberlike(comparable) };
}

export const createAndViewConditionController = (
  targetQuestion: Question,
  rules: string[],
): Function[] => {
  const handlers = rules.map(rule => createGenericRule(rule));
  const results = ['', ''];
  return handlers.map((handler, idx) => {
    return eventBus().on( Events.questionIntermediateChangeEvent(handler.affectingQuestionId), (value) => {
      results[idx] = value;
      const oldHideValue = targetQuestion.hide;
      const newHideValue = !handlers.every((handler, idx) =>
        handler.op(numberIfNumberlike(results[idx]), handler.comparable),
      );
      if (newHideValue !== oldHideValue) {
        targetQuestion.hide = newHideValue;
        eventBus().emit( Events.Type.QuestionViewConditionChange, targetQuestion.questionId );
      }
    },
    );
  });
};

export const createViewConditionController = ( targetQuestion: Question, rule: string ): Function | void => {
  if (rule.startsWith('rule::')) {
    const handler = createGenericRule(rule);
    return eventBus().on( Events.questionIntermediateChangeEvent(handler.affectingQuestionId), (value) => {
      const oldHideValue = targetQuestion.hide;
      const newHideValue = !handler.op( numberIfNumberlike(value), handler.comparable ); // returns true if needs to show
      if (newHideValue !== oldHideValue) {
        targetQuestion.hide = newHideValue;
        eventBus().emit( Events.Type.QuestionViewConditionChange, targetQuestion.questionId );
      }
    },
    );
  }
};
